/** @jsxImportSource @emotion/react */
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Text from '@Text';
import DOMPurify from 'isomorphic-dompurify';
import striptags from 'striptags';
import { isDOMPurifySupported } from './HtmlHelpers';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const Html = ({ text, componentId }) => {
  const theme = useTheme();
  let sanitisedText;
  if (!isDOMPurifySupported()) {
    // If DOMPurify is not supported it defaults to the original string.
    // Instead strip all tags from string to prevent script injection.
    sanitisedText = striptags(text);
  } else {
    // DOMPurify strips all tags other than those specified as well as any attributes such as onload.
    sanitisedText = DOMPurify.sanitize(text, {
      ALLOWED_TAGS: ['i', 'strong', 'b', 'br', 'ol', 'ul', 'li'],
    });
  }
  const containsListTags = /<(ol|ul|li)>/i.test(sanitisedText);
  const variant = containsListTags ? 'contentWithList' : 'note';

  const textExperimentName = useGetExperimentName({
    componentId,
    componentName: 'Text',
  });

  return (
    <Container maxWidth="md" disableGutters>
      <Box
        marginBottom={theme.mvf.spacing.small}
        marginTop={theme.mvf.spacing.small}
        data-testid="html"
      >
        <Text variant={variant} experimentName={textExperimentName}>
          {/* eslint-disable react/no-danger */}
          {/* dangerouslySetInnerHTML should only be used with sanitised html text. */}
          <span dangerouslySetInnerHTML={{ __html: sanitisedText }} />
        </Text>
      </Box>
    </Container>
  );
};

export default Html;
